import { Link } from 'react-router-dom';
import { VENDOR_CATEGORIES } from '@/types/vendor';

const CategoriesSection = () => {
  return (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <span className="text-primary font-medium mb-2 block">Todo lo que necesitas</span>
          <h2 className="font-serif text-4xl md:text-5xl font-semibold text-foreground mb-4">
            Categorías de Proveedores
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Encuentra todo lo necesario para tu boda en un solo lugar. 
            Desde el lugar perfecto hasta los últimos detalles de decoración.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-4">
          {VENDOR_CATEGORIES.map((category) => (
            <Link
              key={category.id}
              to={`/vendors?category=${category.id}`}
              className="group"
            >
              <div className="relative bg-card rounded-2xl p-6 text-center transition-all duration-300 hover:shadow-card hover:-translate-y-1 border border-border hover:border-primary/30">
                <span className="text-4xl mb-4 block group-hover:scale-110 transition-transform duration-300">
                  {category.icon}
                </span>
                <h3 className="font-semibold text-foreground mb-1 group-hover:text-primary transition-colors">
                  {category.name}
                </h3>
                <p className="text-xs text-muted-foreground line-clamp-2">
                  {category.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategoriesSection;
